import { AddMouseDownListener, AddMouseMoveListener, CreateElement, Log, LogGroup, MouseMoveEvent, Point, Scale, Size } from "../../MyHelpers";
import Matter, { Render, Vertices, World } from "matter-js";
import * as PIXI from 'pixi.js';
import { Resourceful } from "../../ResourceManager/Resourceful";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";
import { PixiSprite } from "../Sprite/PixiSprite";
//import { SlotSymbolSprite } from "../SlotSymbolSprite";
//import * as matterwrap from "matter-wrap";
import { ISystemContext } from "../../Context/SystemContext";
import { IInterval } from "../../Context/Interval";
//import { IBoundingBox } from "./FillingPotv2";
import PolyDecomp from "poly-decomp";
import { IAttachment, IBone, ISlot, Spine } from "pixi-spine";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { ITimeout } from "../../Context/Timeout";

//options comments 
//restitution its for how elastic body will be 
//friction how many its the friction whit other bodies
//isStatic its for dosent enable gravity for that body 

// provide concave decomposition support library
Matter.Common.setDecomp(PolyDecomp);
//wrap its use for auto wrap all body on the same engine render 
//Matter.use('matter-wrap');

interface objectScene {
    animatedSprite?: PIXI.AnimatedSprite,
    particle: Matter.Body,
    //simpleImg?: PIXI.Sprite,
    //boundingBox: any
}

export interface IParticlesSaveData {
    positionParticle: Matter.Vector,
    rotationParticle: number,
    texture: number,
    boudingBox: number,
    category: number,
}

interface IParticlesTexturePhisic {
    boudingBox: any[],
    center: Matter.Vector,
    texture: PIXI.Texture[],
}

export interface IMyBoundingBox {
    boundingbox: number[],
    imgwidth: number;
    imgheight: number;
}

export interface IBoundingBox extends IAttachment {
    vertices: number[],
}


export type OnCreateMatterCallbackHandler = () => void;

export class FillingPotPhysical implements Resourceful {
    protected viewMatterCanvasSize = new Size(Scale.W(1920), Scale.H(1080) *  Settings.Screens);
    protected engine: Matter.Engine = null;
    protected render: Matter.Render = null;
    protected runner: Matter.Runner = null
    //protected view: HTMLElement = null;
    protected app: PIXI.Application<HTMLCanvasElement> = null;
    protected gameName: string = null;
    protected logGroup: LogGroup = null;
    protected resid: ResourceIdentifier = null;
    // sceneObjectsBonusHit: objectScene[] = [];
    protected sceneObjectsFillingPot: objectScene[] = [];
    protected particlesSaveData: IParticlesSaveData[] = [];
    protected appTicker: PIXI.Ticker = null;
    protected symbolWinShowParticleTexture: PIXI.Texture<PIXI.Resource>;
    protected textureParticle = [];
    protected systemContext: ISystemContext = null;
    protected particlesWinBonusInterval: IInterval = null;
    //protected numParticlesPerInterval: number = 1;
    protected readonly numForTotalFoutainParticles: number = 60;
    //create container for filling Pot 
    protected containerParticlesHit: PIXI.Container = null;
    //always by defaut needs disable because use more performance for use 2 canvas at same time 
    protected debugerMatter: boolean = false;
    protected debugerMatterBackgroundColor: string = "rgba(0, 0, 0, 0)";
    protected boundingBoxUpdatePostionPoint: Point = new Point(0, 0);
    protected boundingBoxUpdateBone: IBone = null;
    protected intervalStopsRenderMatter: ITimeout= null;


    protected numParticles: number = 35;
    protected readonly defaultnumParticles: number = 35;

    constructor(gameName: string, logGroup: LogGroup, resid: ResourceIdentifier, systemContext: ISystemContext , controlScalePoint : Point) {
        this.gameName = gameName;
        this.logGroup = logGroup;
        this.resid = resid;
        //this.view = view;
        this.systemContext = systemContext;
        this.controlScalePoint = controlScalePoint;
        //console.log("ControlScalePointFamily:", controlScalePoint);
        let countParticles = 0;
        this.particlesWinBonusInterval = this.systemContext.TimingContext().CreateInterval("particlesIntervalFillingPot", 25, () => {
            if(this.updateMatter == false ) this.StartUpdatePhisical();
            if (countParticles < this.numForTotalFoutainParticles) {
                //this.intervalStopsRenderMatter.Stop();    
                //this.updateMatter = true;               
                this.GenerateRandomParticle(true)
                countParticles++;
            }
            else {
                this.particlesWinBonusInterval.Stop();
                countParticles = 0;
            }
        });

        // this.particlesCollectSpawnInterval = this.systemContext.TimingContext().CreateInterval("particlesIntervalFillingPot", 25, () => {
        //     if (countParticles < this.numParticles) {
        //         this.GenerateRandomParticle(false)
        //         countParticles++;
        //     }
        //     else {
        //         this.particlesCollectSpawnInterval.Stop();
        //         countParticles = 0;
        //     }
        // });

        this.intervalStopsRenderMatter = this.systemContext.TimingContext().CreateTimeout("intervalStopsRenderMatter",10000 , ()=>{
            //this.updateMatter = false ;
            this.StopsUpdatePhisical();
        })
    }

    public async PrepareResources(resourceManager: IWriteOnlyResourceManager): Promise<void> {
        //resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/winShowParticles`, this.resid.Add("Symbol-winShowParticles").Shared(), true, this.logGroup.Add("Symbol-winShowParticles"), true));
        for (let textureIndex = 0; textureIndex <= 2; textureIndex++) {
            resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle${textureIndex}`, this.resid.Add(`Symbol-Partitle${textureIndex}`).Shared(), true, this.logGroup.Add(`Symbol-Partitle${textureIndex}`), true));
            resourceManager.Add(new JSONResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle${textureIndex}-BoundingBox.json`,
                this.resid.Add(`Symbol-PartitleBoundingBox${textureIndex}`).Shared().CSSScope(), true));
        }

        //resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle1`, this.resid.Add("Symbol-Partitle1").Shared(), true, this.logGroup.Add("Symbol-Partitle1"), true));
        //resourceManager.Add(new PixiSpriteResource(Settings.ResourcesFolder + `multigame/slot/${this.gameName}/resources/FillingPotFeature/symbolFillingPotPartitle2`, this.resid.Add("Symbol-Partitle2").Shared(), true, this.logGroup.Add("Symbol-Partitle2"), true));
    }

    protected particleSize: Size = new Size(0, 0);
    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
        //this.LoadedParticlesWinShow(resourceManager);
        this.LoadedDifferentsParticlesHitSRA(resourceManager);
    }

    protected particlesTexturesMap: Map<string, PIXI.Texture[]> = new Map<string, PIXI.Texture[]>();
    protected particlesTexturesBoundingBoxMap: Map<string, IParticlesTexturePhisic> = new Map<string, IParticlesTexturePhisic>();
    protected LoadedDifferentsParticlesHitSRA(resourceManager: IReadOnlyResourceManager) {     
        //console.log("ControlScaleResourcesLoaded:", this.controlScalePoint); 
        for (let a = 0; a < 2; a++) {
            let jsonBoundingBox = (resourceManager.Get<JSONResource>(this.resid.Add(`Symbol-PartitleBoundingBox${a}`).Shared().CSSScope()).json) as IMyBoundingBox;
            //console.log(`ParticleBoundingBox-${this.gameName}:`,jsonBoundingBox.boundingbox)
            let verticesConvertedToBoundingBoxPoint = [];
            jsonBoundingBox.boundingbox.forEach((value, index) => {
                if (index % 2 === 0) {
                    verticesConvertedToBoundingBoxPoint.push(new PIXI.Point(jsonBoundingBox.boundingbox[index] * Scale.W(this.controlScalePoint.x), jsonBoundingBox.boundingbox[index + 1] * Scale.H(this.controlScalePoint.y)));
                }
            });
            
            //console.log("boundingBoxConverted:", verticesConvertedToBoundingBoxPoint);
            //let centerVertices = Matter.Vertices.centre(verticesConvertedToBoundingBoxPoint);
            //console.log("centerVertices:", centerVertices);
            //Matter.Vertices.scale(verticesConvertedToBoundingBoxPoint, 1, -1, centerVertices);

            let sprite: PixiSprite = resourceManager.Get<PixiSpriteResource>(this.resid.Add(`Symbol-Partitle${a}`).Shared()).sprite;
            let textures: PIXI.Texture[] = [];

            let boundingBoxScaledWidth = Scale.W(jsonBoundingBox.imgwidth);
            //let boundingBoxScaledHeight = Scale.H(jsonBoundingBox.imgheight);

            let needScalingTexture = Math.abs(sprite.DecodedFrames[0].width - boundingBoxScaledWidth) > 3;

            for (let decodedFrames of sprite.DecodedFrames) {
                //console.log(`Symbol_FrameDecode ${s.ID}`, decodedFrames);
                let baseTexture = new PIXI.BaseTexture(new PIXI.ImageBitmapResource(decodedFrames[0]));

                // scale texture when loaded
                if (needScalingTexture)
                {
                    baseTexture.width = Scale.W(baseTexture.width);
                    baseTexture.height = Scale.H(baseTexture.height);
                }
                let symbolTexture = new PIXI.Texture(baseTexture);
                textures.push(symbolTexture);
                symbolTexture = null;
                baseTexture = null;
                needScalingTexture = null;
            }

            this.particlesTexturesMap.set(`Particle-${a}`, textures);

            let center = Matter.Vector.create(jsonBoundingBox.imgwidth / 2, jsonBoundingBox.imgheight / 2);

            //Matter.Vertices.scale(randomParticleTexture.boudingBox, 1, -1, randomParticleTexture.center)

            let particleTexture: IParticlesTexturePhisic = {
                boudingBox: Matter.Vertices.scale(Matter.Vertices.hull(verticesConvertedToBoundingBoxPoint) as any[], 1, -1, center),
                center: center,
                texture: textures,
            };



            this.particlesTexturesBoundingBoxMap.set(`Particle-${a}`, particleTexture);
            sprite = null;
            textures = null;
            center = null;
            jsonBoundingBox = null;
            //console.log(`LoadedDifferentsParticlesHitSRA(): ${JSON.stringify(center)}`);
            //textureParticle = null;
        }
        //console.log("particleHitTextures:", this.particlesTexturesBoundingBoxMap);
    }


    // protected LoadedParticlesWinShow(resourceManager: ResourceManager) {
    //     let sprite: PixiSprite = resourceManager.Get<PixiSpriteResource>(this.resid.Add("Symbol-winShowParticles").Shared()).sprite;
    //     //sprite.DecodedFrames
    //     for (let decodedFrames of sprite.DecodedFrames) {
    //         //console.log(`Symbol_FrameDecode ${s.ID}`, decodedFrames);
    //         let baseTexture = new PIXI.BaseTexture(new PIXI.ImageBitmapResource(decodedFrames));
    //         //baseTexture.scaleMode;
    //         let scaleWidth = Scale.H(300) / baseTexture.width;
    //         let scaleHeight = Scale.W(250) / baseTexture.height
    //         let scale = Math.min(scaleWidth, scaleHeight);
    //         baseTexture.width = baseTexture.width * scale;
    //         baseTexture.height = baseTexture.height * scale
    //         // baseTexture.width = this.spinnableReels.GetSymbolSize().width;
    //         // baseTexture.height = this.spinnableReels.GetSymbolSize().height;
    //         this.symbolWinShowParticleTexture = new PIXI.Texture(baseTexture);
    //         this.textureParticle.push(this.symbolWinShowParticleTexture);
    //         //console.log("FillingPotParticleTexture:", this.symbolParticleTexture);
    //     }
    //     let randomSize = 0.50;
    //     this.particleSize.width = this.symbolWinShowParticleTexture.width * randomSize;
    //     this.particleSize.height = this.symbolWinShowParticleTexture.height * randomSize;
    // }


    protected created: boolean = false;
    //protected particlesInit: Point = new Point(this.viewMatterCanvasSize.width / 2, this.viewMatterCanvasSize.height / 2);
    //protected boundingBox: IBoundingBox = null;
    protected containerBonusWinParticles: PIXI.Container = null;
    //create bone for boudingBoxes
    protected bonePotRootPhysics: IBone = null;
    protected spawnPosition: Matter.Vector = null;
    protected spineHit: Spine = null;
    protected matterPolygon: Matter.Body = null;
    /** use for create App Pixi.js*/
    public Create(app: PIXI.Application<HTMLCanvasElement>, spineHit: Spine) {
        this.app = app;
        this.created = true;
        //this.particlesInit = particlesInit;      
        this.spineHit = spineHit;
        this.InternalCreate();
    }

    /** use for create pixi and registred for dont create multi times */
    public InternalCreate() {
        if (!this.created) {
            Log.Error(this.logGroup, `Create() FillingPotPhiyical: app not null, don't recreate`);
            return;
        }
        //create engine
        this.createEngine();
    }



    //protected offsetPoint: Point = new Point(Scale.X(61), Scale.Y(10));
    //its use for know if you spine was scaled whit some bone into software dev. 
    protected controlScalePoint : Point = null;
    protected createEngine() {

        // if (this.engine != null) {
        //     //Matter.Render.stop(this.engine.render);
        //     Matter.World.clear(this.engine.world, false);
        //     Matter.Engine.clear(this.engine);
        //     if (this.render != null) Matter.Render.stop(this.render);
        //     this.engine = null;
        //     this.render = null;
        // }

        // create an engine
        this.engine = Matter.Engine.create({
            constraintIterations: 1,
            positionIterations: 2,
            velocityIterations: 2,
            gravity: {
                y: 2,
            }
        });

        //this.engine.gravity.y = 1;

        // // create a renderer
        if (this.debugerMatter == true) {
            this.render = Matter.Render.create({
                //element: this.view,
                element: document.body,
                engine: this.engine,
                
                options: {                    
                    width: this.viewMatterCanvasSize.Width,
                    height: this.viewMatterCanvasSize.Height,
                    wireframes: false,
                    showDebug: true,
                    //showAngleIndicator: true,
                    //showPositions: true,
                    //showCollisions: true,                
                    wireframeBackground: this.debugerMatterBackgroundColor,
                    background: this.debugerMatterBackgroundColor,
                }
            });
            this.render.canvas.style.position = "absolute";

            //create mouse control for test it 
            // add mouse control
            var mouse = Matter.Mouse.create(this.app.view),
                mouseConstraint = Matter.MouseConstraint.create(this.engine, {
                    mouse: mouse,
                    constraint: {
                        stiffness: 0.2,
                        render: {
                            visible: true
                        }
                    }
                });

            this.render.mouse = mouse

            Matter.Composite.add(this.engine.world, mouseConstraint);
            // keep the mouse in sync with rendering
            //this.render.mouse = mouse;
        }
        if (this.render != null) {
            // AddMouseDownListener(this.render.canvas as HTMLCanvasElement, () => {
            //     this.particlesWinBonusInterval.Start();
            // });
        }
        else {
            // AddMouseDownListener(this.app.view, () => {
            //     this.sceneObjectsFillingPot.forEach(ele => {
            //         Matter.Body.setVelocity(ele.particle, { x: Matter.Common.random(5, -5), y: Matter.Common.random(-5, -10) });
            //     });
            // });
        }


        let wallRight = Matter.Bodies.rectangle(
            this.viewMatterCanvasSize.Width,
            this.viewMatterCanvasSize.Height / 2,
            50,
            this.viewMatterCanvasSize.Height,
            {
                isStatic: true,
                collisionFilter: {
                    category: this.worldCategory,
                    //mask: this.particle1Category | this.particle2Category | this.particle3Category | this.worldCategory,
                },
            }
        );

        let wallLeft = Matter.Bodies.rectangle(0, this.viewMatterCanvasSize.Height / 2, 50, this.viewMatterCanvasSize.Height, {
            isStatic: true,
            collisionFilter: {
                category: this.worldCategory,
                //mask: this.particle1Category | this.particle2Category | this.particle3Category | this.worldCategory,
            },
        });

        let wallBottom = Matter.Bodies.rectangle(
            this.viewMatterCanvasSize.Width / 2,
            this.viewMatterCanvasSize.Height,
            this.viewMatterCanvasSize.Width,
            50,
            {
                isStatic: true,
                restitution: 0,
                density: 1,
                friction: 1,
                collisionFilter: {
                    category: this.worldCategory,
                    //mask: this.particle1Category | this.particle2Category | this.particle3Category | this.worldCategory,
                },
            }
        );

        // let wallTop = Matter.Bodies.rectangle(
        //     0,
        //     0,
        //     this.viewMatterCanvasSize.width * 2,
        //     50,
        //     {
        //         isStatic: true,
        //         restitution: 0,
        //         density: 1,
        //         friction: 1,
        //         collisionFilter: {
        //             category: this.worldCategory,         
        //             mask : this.particle1Category | this.particle2Category | this.particle3Category | this.worldCategory,
        //         },
        //     }
        // );


        let wallReels = Matter.Bodies.rectangle(
            this.viewMatterCanvasSize.Width / 2,
            (Settings.ScreenHeight * (Settings.Screens - 1) + (40)),
            this.viewMatterCanvasSize.Width,
            50,
            {
                isStatic: true,
                restitution: 0,
                density: 1,
                friction: 1,
                collisionFilter: {
                    category: this.worldCategory,
                    //mask: this.particle1Category | this.particle2Category | this.particle3Category | this.worldCategory,
                },
            }
        );

        // change frame rate to 60 fps
        //this.engine.timing.lastDelta = 1000 / 60;
        //this.engine.render.options.pixelRatio = 2;
        //this.engine.velocityIterations = 2;


        let slotPotRootPhysics = this.spineHit.skeleton.findSlot("potRootPhysics");
        //console.log("DataSpineSlotBoundinBox:", slotPotRootPhysics);

        if (slotPotRootPhysics == null)
        {
            throw "Bone potRootPhysics not found in spine!";
        }


        {
            let boundingBox = slotPotRootPhysics.getAttachment() as IBoundingBox;
            //console.log("DataSpineBoundinBox:", boundingBox);
            //console.log("boundingBox:", boundingBox);
            let verticesConverted = [];            
            boundingBox.vertices.forEach((value, index) => {
                if (index % 2 === 0) {
                    verticesConverted.push(new PIXI.Point(boundingBox.vertices[index] * Scale.H(1), boundingBox.vertices[index + 1] * Scale.W(1)));
                }
            });
            //console.log("boundingBoxConverted:", verticesConverted);

            let centerVertices = Matter.Vertices.centre(verticesConverted);
            //Matter.Vertices.centre(verticesConverted);
            //console.log("AREA:", Matter.Vertices(verticesConverted,true));
            console.log("centerVertices:", centerVertices);
            Matter.Vertices.scale(verticesConverted, 1, -1, centerVertices);

            this.matterPolygon = Matter.Bodies.fromVertices(
                centerVertices.x, 
                Settings.Enable2plus1 == true ? centerVertices.y + Settings.ScreenHeight : centerVertices.y, 
                verticesConverted, 
                {
                    isStatic: true,
                    render: {
                        fillStyle: "rgba(255,255,255,0.7)"
                    },
                    collisionFilter: {
                        category: this.worldCategory,
                        //mask: this.particle1Category | this.particle2Category | this.particle3Category,
                    }
                }, 
                true, 
                0.001, 
                0.0001
            );
            //add everything to world 
            Matter.Composite.add(this.engine.world, [this.matterPolygon]);
            centerVertices = null;
            slotPotRootPhysics = null;
            verticesConverted = null;
            boundingBox = null;
            //anguloRotacion = null;
        }




        let boneRootFixPosition = this.spineHit.skeleton.findBone("particlesHit");
        if (boneRootFixPosition == null)
        {
            throw "Bone particlesHit not found in spine!";
        }

        // boneRootFixPosition.data.scaleX = Scale.X(1);
        // boneRootFixPosition.data.scaleY = Scale.Y(1);



        {
            //console.log(`Spawn original: ${JSON.stringify({x: boneRootFixPosition.data.x, y: boneRootFixPosition.data.y})}`);

            let x = boneRootFixPosition.data.x;
            let y = boneRootFixPosition.data.y ;

            // TODO is this correct fix?
            if (boneRootFixPosition.data.x < 0) x = boneRootFixPosition.data.x * -1;
            if (boneRootFixPosition.data.y < 0) y = boneRootFixPosition.data.y * -1;
            let spawnPositionFixed = Matter.Vector.create(x, y);
            //console.log(`Spawn fixed: ${JSON.stringify(spawnPositionFixed)}`);

          
            //console.log(`Spawn scaled: ${JSON.stringify(spawnPositionFixed)}`);



            //add container to particlesHit


            let containerchildrensSpine = this.spineHit.children as PIXI.Container[];

            let particlesHit = containerchildrensSpine.find(c => c.name == "particlesHit");
            if (particlesHit == null)
            {
                throw "Container particlesHit not found in spine!";
            }

            //create container 
            this.containerParticlesHit = new PIXI.Container();
            this.containerParticlesHit.name = "containerParticlesHit";
            //console.log("boneRootFixPosition:", this.positionParticlesContainer)
            this.containerParticlesHit.pivot.set(spawnPositionFixed.x, spawnPositionFixed.y );
            this.containerParticlesHit.scale.set(1, -1);
            

            let fixPositionY = Settings.Enable2plus1 == true ? Scale.Y(y) + Scale.Y(1080) : Scale.Y(y);
            this.spawnPosition = Matter.Vector.create(Scale.X(x), fixPositionY);

            particlesHit.addChild(this.containerParticlesHit);
            //particlesHit.parent.addChildAt(this.containerParticlesHit, particlesHit.parent.getChildIndex(particlesHit) +1);
            this.containerParticlesHit.updateTransform();

            // //create container 
            // this.containerBonusWinParticles = new PIXI.Container();
            // this.containerBonusWinParticles.width = this.viewMatterCanvasSize.width;
            // this.containerBonusWinParticles.height = this.viewMatterCanvasSize.height;
            // this.containerBonusWinParticles.name = "ContainerParticles";
            // this.app.stage.addChild(this.containerBonusWinParticles);
        }


        //add everything to world 
        Matter.Composite.add(this.engine.world, [wallLeft, wallBottom, wallRight, wallReels]);
        //Matter.Runner.run(this.engine);
        if (this.debugerMatter == true) Matter.Render.run(this.render);       



        // for (let a = 0; a <= 25; a++) {
        //     this.createIncrementPhysic({ x: 0, y: 0 });
        // }
        //this.particlesCollectSpawnInterval.Start();



        //this.updateMatter = true;
        this.StartUpdatePhisical();


        wallLeft = null; 
        wallBottom = null; 
        wallRight = null;
        wallReels = null;

        this.OnCreatedMatterCallback?.();
    }

    /** use for destroy  engine Matter.js if that exist*/
    public Destroy() {
        this.InternalDestroy();
        this.created = false;
    }

    public InternalDestroy() {

        if (!this.created) {
            Log.Debug(this.logGroup, `Destroy() - FillingPotPhysical: no app, not destroying anything`);
            return;
        }
        this.particlesWinBonusInterval?.Stop();
        this.sceneObjectsFillingPot.forEach(obj => {
            Matter.Composite.remove(this.engine.world, obj.particle,true);            
            obj.animatedSprite.removeFromParent();
            obj.animatedSprite.destroy({children : true , baseTexture : true});            
            obj.particle = null;
            obj.animatedSprite = null;
            //obj.boundingBox = null;
        })

        this.containerParticlesHit.removeFromParent();
        this.containerParticlesHit.destroy({children : false , baseTexture : true , texture : true});
        this.containerParticlesHit = null;

        //Matter.Render.stop(this.engine.render);
        this.sceneObjectsFillingPot = [];
        //this.containerBonusWinParticles.removeFromParent();
        //this.containerBonusWinParticles.removeChildren();
        //this.containerBonusWinParticles.destroy(true);
        this.containerBonusWinParticles = null;
        Matter.World.clear(this.engine.world, true);
        this.engine.world = null;        
        Matter.Engine.clear(this.engine);
        if (this.render != null) Matter.Render.stop(this.render);
        this.engine = null;
        this.render = null;
        //this.updateMatter = false;
        this.StopsUpdatePhisical();
        //this.app.ticker.stop();
        //this.app.ticker.destroy();        
        //this.sceneObjectsBonusHit = [];

    }

    public StartBonusWin() {
        this.particlesWinBonusInterval.Start();
    }

    protected worldCategory: number = 0b0001;    
    //protected particle1Category: number = 0b0001;
    //protected particle2Category: number = 0b0010;
    //protected particle3Category: number = 0b0100;
    //protected particleBonusWin1Category: number = 5;
    //protected particleBonusWin2Category: number = 6;
    //protected particleBonusWin3Category: number = 7;
    protected categoryParticles: number[] = [
        1, 2, 4, 8, 32, 
    ];
    protected categoryParticlesColor: string[] = [
        "rgba(255,0,0,0.5)", "rgba(10,255,100,0.5)", "rgba(0,0,255,0.5)","rgba(255,50,100,0.5)","rgba(255,100,0,0.5)"
    ];

    protected numForTotalParticles: number = 300;
    public createIncrementPhysic(velocityParticles: Matter.Vector, randomPostionParticles: Matter.Vector, randomParticleTexture: IParticlesTexturePhisic, randomCategory: number, randomParticleIndex: number) {

        if (!this.engine)
        {
            // engine not created yet or already destroyed
            return;
        }

        if (this.particlesSaveData.length >= this.numForTotalParticles)
        {
            // enough particles
            return;
        }

        let randomColorParticle = this.categoryParticlesColor.random();

        //let randomColorParticle: string = this.categoryParticlesColor[randomCategory - 2];

        //Matter.Vertices.scale(randomParticleTexture.boudingBox, 1, -1, randomParticleTexture.center)


        let matterCoinPolygon = Matter.Bodies.fromVertices(
            randomPostionParticles.x, 
            randomPostionParticles.y, 
            randomParticleTexture.boudingBox, 
            {
                //isStatic: true,
                collisionFilter: {
                    category: randomCategory,
                    mask: randomCategory | this.worldCategory,
                    group: randomCategory,
                },
                render: {
                    fillStyle: randomColorParticle,
                }
            }
        );

        Matter.Composite.add(this.engine.world, [matterCoinPolygon]);
        Matter.Body.setVelocity(matterCoinPolygon, velocityParticles);


        //console.log("-------------- ParticleFinished --------------:");

        // let particleTexture = [];


        // for (let value of randomParticleTexture.texture.values()) {
        //     //console.log(value);
        //     particleTexture.push(value);
        //     value = null;
        // }
        // Pixi Sprite        
        let imageSprite = new PIXI.AnimatedSprite(randomParticleTexture.texture);
        //imageSprite.width = this.particleSize.width;
        //imageSprite.height = this.particleSize.height;
        imageSprite.zIndex = randomCategory;
        imageSprite.anchor.set(0.5, 0.57); 
        imageSprite.scale.set((this.controlScalePoint.x), (this.controlScalePoint.y))
        imageSprite.position = matterCoinPolygon.position;
        imageSprite.rotation = matterCoinPolygon.angle;
        //imageSprite.textures = this.particlesTexturesMap.get(`Particle-${RandomTexture}`);
        //imageSprite.updateTransform();
        this.containerParticlesHit.addChild(imageSprite);

        // Add the complete scene object (body and sprite) to our array of objects. We'll track those objects in the pixi frame updates (see app.ticker below).
        this.sceneObjectsFillingPot.push({
            particle: matterCoinPolygon,
            animatedSprite: imageSprite,
            //boundingBox: null
        });

      
        
        this.particlesSaveData.push({
            positionParticle: {...matterCoinPolygon.position},
            rotationParticle: 0,
            texture: randomParticleIndex,
            boudingBox: randomParticleIndex,
            category: randomCategory
        });
        //console.log("PArticlesSaved:",this.particlesSaveData)
        matterCoinPolygon = null;
        imageSprite = null;
        randomColorParticle = null;
        velocityParticles = null;
        randomPostionParticles = null;
        randomParticleTexture = null;
        randomCategory = null;
        randomParticleIndex = null;
    }

    protected updateMatter: boolean = false;
    public StopsUpdatePhisical() {        
        this.updateMatter = false;
        this.SaveCurrentPositionParticle();
        //console.log("MatterUpdate-Stats:", this.updateMatter);
        //this.CleanParticlesBets();
    }

    public StartUpdatePhisical() {
        this.updateMatter = true;
        //console.log("MatterUpdate-Stats:", this.updateMatter);
    }



    public Update() {
        //this.app?.ticker.update(1000 / 60);
        if (this.updateMatter == true) {
            this.sceneObjectsFillingPot.forEach((object, index) => {
                // Make all pixi sprites follow the position and rotation of their body.
                object.animatedSprite.position = object.particle.position;
                object.animatedSprite.rotation = object.particle.angle;
                // object.particle.plugin.wrap = {
                //     min: { x: this.render.bounds.min.x, y: this.render.bounds.min.y },
                //     max: { x: this.render.bounds.max.x, y: this.render.bounds.max.y }
                // };
                //object.animatedSprite.play()
                //object.animatedSprite.loop = false;
            });

            if (this.engine != null) Matter.Engine.update(this.engine); // Actualiza el motor Matter.js
            // // Aquí puedes agregar cualquier otra lógica de actualización adicional
            if (this.render != null) Matter.Render.world(this.render); // Renderiza la escena
        }
    }

    protected SaveCurrentPositionParticle() {
        // Add the complete scene object (body and sprite) to our array of objects. We'll track those objects in the pixi frame updates (see app.ticker below).
        this.sceneObjectsFillingPot.forEach((ele, index) => {
            this.particlesSaveData[index].positionParticle = { ...ele.particle.position };
            let savenewAngle =  ele.particle.angle;
                this.particlesSaveData[index].rotationParticle = savenewAngle
        })
    }

    public GetParticlesSaved(): IParticlesSaveData[] {
        return this.particlesSaveData
    }
    public SetBet(particlesSaveData: IParticlesSaveData[] , levelParticlesBackendIncrementSaved? : number) {
        this.numParticles   = levelParticlesBackendIncrementSaved > 0 ? levelParticlesBackendIncrementSaved : this.defaultnumParticles;
        //this.particlesCollectSpawnInterval.Stop();
        //this.updateMatter = false;
        this.SaveCurrentPositionParticle();
        
        this.StopsUpdatePhisical();

        this.CleanParticlesBets();
      
        this.RestoreParticles(particlesSaveData);
        //this.updateMatter = true;
        this.StartUpdatePhisical();
    }

    //readonly weights = [0.1, 0.99, 1.0];
    readonly weights = [0.2, 1]
    public GenerateRandomParticle(bonusWin: boolean) { 
        if(this.updateMatter == false ) this.StartUpdatePhisical();
        this.intervalStopsRenderMatter.Stop();
        
        let randomPercent = Math.random();
        let randomIndex = this.weights.findIndex(p => randomPercent < p);
        let randomCategory = this.categoryParticles.random();
        let particles = [...this.particlesTexturesBoundingBoxMap.values()];
        let randomParticleTexture = particles[randomIndex];

        //let position = { x: this.spawnPosition.width, y: this.spawnPosition.height };
        //console.log(`GenerateRandomParticle() position: ${JSON.stringify(this.spawnPosition)} index: ${randomIndex} category: ${randomCategory}}`);

        if (bonusWin == true)
        {
            let velocity = { x: Matter.Common.random(-1, 1), y: -60 };
            this.createIncrementPhysic(velocity, this.spawnPosition, randomParticleTexture, randomCategory, randomIndex);
            velocity = null;
        }
        else
        {
            let velocity = { x: Matter.Common.random(-10, 10), y: Matter.Common.random(0, -8) };
            this.createIncrementPhysic(velocity, this.spawnPosition, randomParticleTexture, randomCategory, randomIndex);
            velocity = null;
        }

        this.intervalStopsRenderMatter.Start();
        particles = null;
        randomParticleTexture = null;
        randomCategory = null;
        randomIndex = null;
        randomPercent = null;


    }

    public CleanParticlesBets() {
        this.sceneObjectsFillingPot?.forEach(obj => {
            Matter.Composite.remove(this.engine.world, obj.particle);
            obj.animatedSprite.removeFromParent();
            obj.particle = null;
            obj.animatedSprite = null;
        });

        this.sceneObjectsFillingPot = [];
        this.particlesSaveData = [];
    }

    protected RestoreParticles(particlesSaveData: IParticlesSaveData[]) {
        //console.log("ParticleRestartedSaved:", this.particlesSaveData);
        if (particlesSaveData?.length >= 1) {
            let particles = [...this.particlesTexturesBoundingBoxMap.values()];
            this.StartUpdatePhisical();
            for (let indexParticleSaved = 0; indexParticleSaved < particlesSaveData.length; indexParticleSaved++) {
                //console.log("ParticleSaved:", particlesSaveData[indexParticleSaved]);
                let particleSaved = particlesSaveData[indexParticleSaved];
                let randomParticleTexture = particles[particleSaved.texture];
                this.createIncrementPhysic({ x: 0, y: 0 }, particleSaved.positionParticle, randomParticleTexture, particleSaved.category, particleSaved.boudingBox)
                particleSaved = null;
            }
        } else {
            //this.particlesCollectSpawnInterval.Start();
            //if( countParticles < 25 ){
                //this.StartUpdatePhisical();
                //this.intervalStopsRenderMatter.Stop();    
                //this.updateMatter = true;
            for (let index = 0; index < this.numParticles; index++) {                
                this.GenerateRandomParticle(false)
            }
            //countParticles++;
            //}
        }
    }

    public OnStartBigWinShow() {
        this.StartUpdatePhisical();
        this.intervalStopsRenderMatter.Stop()
        this.sceneObjectsFillingPot.forEach(ele => {
            Matter.Body.setVelocity(ele.particle, { x: Matter.Common.random(5, -5), y: Matter.Common.random(-5, -10) });
        });
        this.intervalStopsRenderMatter.Start()
    }

    public OnCreatedMatterCallback: OnCreateMatterCallbackHandler = null;

    public ParticlesDebugger(){
        if(this.debugerMatter == false) {this.debugerMatter = true}
        else { this.debugerMatter = false}
    }
}
